import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Button, Tag, Icon, Input, Form, Popconfirm } from 'antd'

@inject((store: any) => {
    const { policiesStore } = store
    return { policiesStore }
})
@observer
class Aliases extends Component<any, any> {
    state = {
        newValue: null,
        error: null
    }
    handleChangeValue = newValue => {
        this.setState({ newValue })
    }
    handleSubmitValue = () => {
        const newValue = this.state.newValue.trim()
        const { list, onSubmit } = this.props
        if (list.includes(newValue)) {
            this.setState({ error: 'שם זה כבר קיים' })
        } else {
            const newList = [...list, newValue.trim()]
            onSubmit(newList)
            this.setState({ newValue: null, error: null })
        }
    }
    handleRemoveValue = removeValue => {
        const { list, onSubmit } = this.props
        onSubmit(list.filter(value => value !== removeValue.trim()))
    }
    render() {
        const { error, newValue } = this.state
        const { list, disabled } = this.props
        let addButton = (
            <Button
                type="primary"
                onClick={this.handleSubmitValue}
                disabled={disabled}
                style={{ margin: '0 0.2rem', flexGrow: 1 }}
            >
                הוסף שם
            </Button>
        )
        return (
            <div style={{ textAlign: 'right', width: '100%', padding: '0 0.5rem 0.5rem' }}>
                {list.length > 0
                    ? list.map((alias, index) => (
                          <div
                              key={index}
                              style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  width: '100%',
                                  padding: '0.2rem 0rem',
                                  borderBottom: '1px solid #dedede'
                              }}
                          >
                              <span>{alias}</span>
                              {!disabled ? (
                                  <a
                                      style={{ textDecoration: 'underline', fontWeight: 'bold' }}
                                      onClick={() => this.handleRemoveValue(alias)}
                                  >
                                      הסר שם
                                  </a>
                              ) : (
                                  ''
                              )}
                          </div>
                      ))
                    : 'אין שמות מקבילים'}
                {!disabled ? (
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            this.handleSubmitValue()
                        }}
                        style={{ width: '100%', display: 'flex', marginTop: '1rem' }}
                    >
                        <Input
                            onChange={e => this.handleChangeValue(e.target.value)}
                            style={{ borderColor: error ? 'red' : 'white', padding: '1rem' }}
                            disabled={disabled}
                            size="small"
                            placeholder="הוספת שם מקביל"
                            value={newValue}
                        />
                        {addButton}
                    </Form>
                ) : (
                    ''
                )}
                {error ? <span style={{ color: 'red', fontWeight: 'bold' }}>{error}</span> : ''}
            </div>
        )
    }
}

export default withRouter(Aliases)
